// src/components/Home.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const universalCalculators = [
  {
    id: 'datum-staza',
    title: 'RADNI STAŽ',
    description: 'Obračun radnog staža i pronalazak tačnog datuma za punu godinu radnog staža.',
  },
  { id: 'PDV',
    title: 'PDV ',
    description: 'Obračun PDV-a (bruto/neto) sa različitim stopama.',
  },
  { id: 'kamata',
    title: 'PORESKA KAMATA',
    description: 'Obračun poreske kamate na osnovicu za kašnjenje plaćanja.',
  },
  // po potrebi dodajte još univerzalnih kalkulatora
];


const calculators = [
  { id: 'kalkulator-plata',
    title: 'Puno radno vrijeme',
    description: 'Obračun plate sa uvećanjima i odbicima na platu.',
  },
  {
    id: 'minuli-topli',
    title: 'Puno radno vrijeme + topli obrok',
    description: 'Obračun plate sa uvećanjima i odbicima na platu i toplim obrokom.',
  },
  {
    id: 'ugovor-o-djelu',
    title: 'Ugovor o djelu / Dopunski rad',
    description: 'Obračun prema ugovoru o djelu ili dopunskom radnom odnosu.',
  },
  {
    id: 'privremeni-povremeni',
    title: 'Privremeni i povremeni poslovi',
    description: 'Obračun za privremene i povremene angažmane.',
  },
  {
    id: 'zakup',
    title: 'Zakup imovine',
    description: 'Izračun zakupa pokretne ili nepokretne imovine.',
  },
  {
    id: 'menadzerski-ugovor',
    title: 'Menadžerski ugovor',
    description: 'Obračun bez formalnog radnog odnosa (menadžerski ugovor).',
  },
  {
    id: 'autorski-ugovor',
    title: 'Autorski ugovor',
    description: 'Izračun naknade po autorskom ugovoru.',
  },
  {
    id: 'ostali-dohodak',
    title: 'Ostali dohodak',
    description: 'Obračun ostalih vrsta dohotka.',
  },
  {
    id: 'doprinosi-nekom',
    title: 'Nekomercijalno gazdinstvo',
    description: 'Doprinosi za nekomercijalno gazdinstvo.',
  },
  {
    id: 'doprinosi-kom-pio',
    title: 'Komercijalno gazdinstvo (45/37)',
    description: 'Komercijalno gazdinstvo (osiguranici na PIO).',
  },
  {
    id: 'doprinosi-kom-nepio',
    title: 'Komercijalno gazdinstvo (55/55)',
    description: 'Komercijalno gazdinstvo (nisu osiguranici na PIO).',
  },
  {
    id: 'doprinosi-vlasnik',
    title: 'Vlasnik – osnovno zanimanje (SP)',
    description: 'Doprinosi za vlasnika preduzetničke radnje. Samostalni preduzetnik.',
  },
  {
    id: 'doprinosi-samostalno',
    title: 'Samostalno zanimanje',
    description: 'Doprinosi za samostalnu djelatnost.',
  },
];


const fbihcalculators = [
  { id: 'kalkulator-FBIH',
    title: 'FEDERACIJA BIH',
    description: 'Obračuni plate i doprinosa za puno radno vrijeme u FBIH, sa toplim obrokom, uvećanjima i odbicima.',
  },
];

export default function Home() {
  return (
    <div className="home-wrapper">

      <h1 className="home-title">
        UNIVERZALNI OBRAČUNI
      </h1>
      <div className="cards-grid">
        {universalCalculators.map(calc => (
          <Link key={calc.id} to={`/${calc.id}`} className="card-link">
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>
    
      <h1 className="home-title" style={{ marginTop: '3rem' }}>
        KALKULATORI ZA REPUBLIKU SRPSKU
      </h1>
      <div className="cards-grid">
        {calculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/${calc.id}`}
            className="card-link"
          >
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>
    
      <h1 className="home-title" style={{ marginTop: '3rem' }}>
        KALKULATORI ZA FEDERACIJU BIH
      </h1>
      <div className="cards-grid">
        {fbihcalculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/${calc.id}`}
            className="card-link"
          >
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>

    </div>
  );
}
